import { render, staticRenderFns } from "./MetalDetail.vue?vue&type=template&id=2adc4dd6&"
import script from "./MetalDetail.vue?vue&type=script&lang=js&"
export * from "./MetalDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports